<template>
  <BasePopupModal :modal="modal" :overlay-color="'white'" :width="900">
    <div class="add-agents-modal">
      <div class="add-agents-modal--header font-weight-light">Ajout d'agent(s)</div>
      <div class="add-agents-modal--content">
        <div class="add-agents-modal--content-input d-flex justify-center">
          <div v-if="isShowSelect" class="add-agents-modal--content-list">
            <v-form class="add-agents-modal--content-input-form">
              <v-container>
                <v-autocomplete
                  v-model="selectedAgents"
                  :items="agents"
                  item-value="id"
                  filled
                  label="Ajouter un agent"
                  item-text="concatened"
                  multiple
                  chips
                  clearable
                >
                  <template #selection="{ props, item }">
                    <v-chip v-bind="props">
                      {{ item.concatened }}
                      <v-icon small @click="remove(item)">mdi-close</v-icon>
                    </v-chip>
                  </template>
                  <template #item="{ item }">
                    {{ item.concatened }}
                  </template>
                </v-autocomplete>
              </v-container>
            </v-form>
          </div>
        </div>
      </div>
      <div class="add-agents-modal--buttons d-flex justify-end">
        <v-btn class="add-agents-modal--buttons-cancel" outlined depressed @click="close"> Annuler </v-btn>
        <v-btn class="add-agents-modal--buttons-save" color="#38BB00" :disabled="isDisabled" dark depressed @click="submit"> Valider </v-btn>
      </div>
    </div>
  </BasePopupModal>
</template>

<script>
/**
 * Popup affichée sur la page /sessions, lors de l'ajout d'agent dans la session de formation
 */

import BasePopupModal from '@/components/modals/base/BasePopupModal';

export default {
  name: 'AddAgentsModal',
  components: {
    BasePopupModal
  },
  props: {
    modal: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedAgents: null
    };
  },
  computed: {
    title() {
      return this.modal.payload.text.title;
    },
    isShowSelect() {
      return this.agents.length;
    },
    isDisabled() {
      return !this.selectedAgents || this.selectedAgents.length === 0;
    },
    agents() {
      return this.modal.payload.agents.map(agent => ({
        ...agent,
        concatened: `${agent.lastname} ${agent.firstname} - ${agent.enterpriseName} - ${agent.profileName}`
      }));
    }
  },
  beforeDestroy() {
    this.close();
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async submit() {
      if (this.modal.payload.submit) {
        await this.modal.payload.submit({
          agentIds: this.selectedAgents
        });
        this.close();
      }
    },
    remove(item) {
      this.selectedAgents.splice(this.selectedAgents.indexOf(item), 1);
    }
  }
};
</script>

<style lang="scss">
.modals-container {
  border: 1px solid #ffffff;
}
.add-agents-modal {
  .theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: rgb(56, 187, 0, 0.6) !important;
    border-color: rgb(56, 187, 0, 0.6) !important;
  }

  &--header {
    text-align: center;
  }

  &--content {
    text-align: center;
    margin-top: 10px;
    height: 343px;
    border: 1px solid #e4e6e8;
    border-radius: 10px;

    &-list {
      width: 90%;
      margin-top: 40px;
    }

    &-label {
      font-size: 18px;
      margin-top: 66px;
      text-align: center;
    }

    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
      background-color: white !important;
    }
  }

  &--buttons {
    margin-top: 10px;
    margin-bottom: 20px;
    width: 100%;

    button {
      padding: 10px 0 10px;
      height: 38px;
      width: 121px;
      border-radius: 10px;
      font-size: 14px;
      border: 1px solid #e2e2ea;
      font-weight: 600;
      font-size: 14px;
      text-transform: none;
    }

    &-cancel {
      margin-right: 8px;
      color: #696974 !important;
    }
  }
}
</style>
